import React from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import IngredientDetailCard from '~/components/ingredientDetailCard/ingredientDetailCard';
import IngredientSummaryCard from '~/components/ingredientSummaryCard/ingredientSummaryCard';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import RecentIngredientAdjustmentsCard from '~/containers/recentIngredientAdjustmentsCard/recentIngredientAdjustmentsCard';

export const getIngredientQuery = gql`
  query ingredient($id: Int!) {
    ingredient(id: $id) {
      id
      name
      customsName
      description
      type
      measurementType
      isTracked
      amountOnHand
      products {
        id
        productId
      }
    }
  }
`;

const Ingredient = ({ onCompleted, id }) => (
  <Query query={getIngredientQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      const { ingredient } = data;
      return (
        <div className="flex content">
          <div className="flex-2 mr4">
            <IngredientDetailCard className="mb4" {...ingredient} />
            {ingredient.isTracked && <RecentIngredientAdjustmentsCard {...ingredient} />}
          </div>
          <div className="flex-1">
            <IngredientSummaryCard ingredient={ingredient} />
          </div>
        </div>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(Ingredient);



// WEBPACK FOOTER //
// ./src/containers/ingredient/ingredient.jsx